import Vue from 'vue';
import VueApollo from 'vue-apollo';
import convertObjectPropsToCamelCase from '~/javascripts/lib/convert_object_props_to_camel_case';
import tryJSONParse from '~/javascripts/lib/try_json_parse';
import { apolloClient } from '~/javascripts/lib/graphql';
import DuoProTransactionApp from './components/duo_pro_transaction_app.vue';

Vue.use(VueApollo);

export default function initDuoProTransactionApp() {
  const el = document.querySelector('.js-duo-pro-transaction');

  if (!el) {
    return false;
  }

  const apolloProvider = new VueApollo({ defaultClient: apolloClient });
  const subscription = convertObjectPropsToCamelCase(tryJSONParse(el.dataset.subscription));
  const { zuoraAccountNumber, subscriptionsPath, planId } = el.dataset;

  return new Vue({
    el,
    provide: {
      zuoraAccountNumber,
      subscription,
      planId,
    },
    apolloProvider,
    render(createElement) {
      return createElement(DuoProTransactionApp, {
        props: { subscriptionsPath },
      });
    },
  });
}
